import {} from '@lib/requests/quote';
import type { QuoteResponse } from '@lib/responses/quote';

import type { API } from './api';

export class QuoteService {
  constructor(private api: API) {}

  getQuote = (quoteId: string) => {
    return this.api.get<QuoteResponse>(`/quote/${quoteId}`);
  };

  getQuotePDF = (quoteId: string): Promise<string> => {
    return this.api.get(`/quote/${quoteId}/document`);
  };
}
